if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalWindow {
      constructor() {
        super();
      }
  
      hide() {
        super.hide();
        // Pause all videos when closing modal
        this.querySelectorAll('deferred-media').forEach((media) => {
          const video = media.querySelector('video, iframe');
          if (video) {
            if (video.tagName === 'VIDEO') {
              video.pause();
            } else if (video.tagName === 'IFRAME') {
              // Stop YouTube/Vimeo videos
              video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }
          }
        });
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
          let activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`)
          if (!activeMedia) return;
          
          // this.querySelector("img").srcset = activeMedia.querySelector("img").srcset
        const dataMediaAlt = activeMedia.dataset.mediaAlt
        if (dataMediaAlt) {
          this.querySelectorAll(`[data-media-alt]`).forEach(element => element.classList.remove('product__media-item--variant--alt'))
          this.querySelectorAll(`[data-media-alt="${dataMediaAlt}"]`).forEach(element => element.classList.add('product__media-item--variant--alt'))
        }

        activeMedia.classList.add('active');
        
        // Get the parent slide if activeMedia is the media element itself
        const slideElement = activeMedia.closest('.slider__grid-item') || activeMedia;
        
        // Remove is-active from all slides
        this.querySelectorAll('.slider__grid-item').forEach(slide => slide.classList.remove('is-active'));
        
        // Add is-active to current slide
        slideElement.classList.add('is-active');
        
        slideElement.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        if (activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }
        
        // Update SliderComponent state if it exists
        const sliderComponent = this.querySelector('slider-component');
        if (sliderComponent) {
          // Trigger SliderComponent to update its internal state
          setTimeout(() => {
            if (sliderComponent.update) sliderComponent.update();
            if (sliderComponent.disableButtons) sliderComponent.disableButtons();
          }, 100);
        }
  
        // if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        if (activeMedia.nodeName == 'DEFERRED-MEDIA') {
          activeMedia.loadContent();
          // Auto-play video after loading
          setTimeout(() => {
            const video = activeMedia.querySelector('video');
            if (video) {
              video.play().catch(err => console.log('Autoplay prevented:', err));
            }
          }, 300);
        }
      }
    });
  }
  